import { AsyncState, createAsyncStateReducer } from "react-async-stateful";

import * as RewardsActions from "./Rewards.action";

import * as ReduxUtils from "../../lib/util/ReduxUtils";
import { Competition } from "lib/types/Competition";

export interface RewardsReducerState {
	competitions: AsyncState<{
		[key: string]: Competition;
	}>;
	hasFleetCompetition: boolean;
}

const initialState: RewardsReducerState = {
	competitions: AsyncState.create({}),
	hasFleetCompetition: false,
};

export default ReduxUtils.composeReducer(initialState, [
	createAsyncStateReducer<RewardsReducerState>({
		competitions: RewardsActions.getGroupCompetitions.type,
	}),
]);
